import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboard-container" }
const _hoisted_2 = { class: "stat-item" }
const _hoisted_3 = { class: "stat-icon bg-blue" }
const _hoisted_4 = { class: "stat-info" }
const _hoisted_5 = { class: "stat-value" }
const _hoisted_6 = { class: "stat-item" }
const _hoisted_7 = { class: "stat-icon bg-green" }
const _hoisted_8 = { class: "stat-info" }
const _hoisted_9 = { class: "stat-value" }
const _hoisted_10 = { class: "stat-item" }
const _hoisted_11 = { class: "stat-icon bg-orange" }
const _hoisted_12 = { class: "stat-info" }
const _hoisted_13 = { class: "stat-value" }
const _hoisted_14 = { class: "stat-item" }
const _hoisted_15 = { class: "stat-icon bg-purple" }
const _hoisted_16 = { class: "stat-info" }
const _hoisted_17 = { class: "stat-value" }
const _hoisted_18 = { class: "card-header" }
const _hoisted_19 = { class: "card-header" }
const _hoisted_20 = { class: "additional-stat" }
const _hoisted_21 = { class: "stat-count" }
const _hoisted_22 = { class: "additional-stat" }
const _hoisted_23 = { class: "stat-count" }
const _hoisted_24 = { class: "additional-stat" }
const _hoisted_25 = { class: "stat-count" }
const _hoisted_26 = { class: "pending-stat" }
const _hoisted_27 = { class: "stat-count pending-count" }
const _hoisted_28 = { class: "pending-stat" }
const _hoisted_29 = { class: "stat-count pending-count" }
const _hoisted_30 = { class: "pending-stat" }
const _hoisted_31 = { class: "stat-count pending-count" }

import { ref, onMounted, nextTick, computed, onUnmounted } from 'vue';
import { getAdminDashboardStats, DashboardVO } from '@/admin/api/dashboard';
import { ElIcon, ElRow, ElCol, ElCard, ElRadioGroup, ElRadioButton } from 'element-plus';
import { 
  ChatLineRound, 
  User, 
  UserFilled, 
  Warning 
} from '@element-plus/icons-vue';
import * as echarts from 'echarts';

// 图表引用

export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardView',
  setup(__props) {

const tokenChartRef = ref<HTMLDivElement>();
const userChartRef = ref<HTMLDivElement>();

// 图表实例
let tokenChart: echarts.ECharts | null = null;
let userChart: echarts.ECharts | null = null;

// 数据
const dashboardData = ref<DashboardVO | null>(null);
const loading = ref(true);

// 图表时间周期选择
const tokenPeriod = ref<'daily' | 'weekly' | 'monthly'>('daily');
const userPeriod = ref<'daily' | 'weekly' | 'monthly'>('daily');

// 计算待处理总数
const pendingTotal = computed(() => {
  if (!dashboardData.value) return 0;
  return (
    dashboardData.value.pendingPostCount +
    dashboardData.value.pendingCommentCount +
    dashboardData.value.pendingReportCount
  );
});

// 初始化图表
const initCharts = async () => {
  await nextTick();
  
  // 初始化ECharts图表
  if (tokenChartRef.value) {
    tokenChart = echarts.init(tokenChartRef.value);
    updateTokenChart();
  }

  if (userChartRef.value) {
    userChart = echarts.init(userChartRef.value);
    updateUserChart();
  }
};

// 更新Token图表
const updateTokenChart = () => {
  if (!tokenChart || !dashboardData.value) return;

  let trendData;
  let periodLabel;
  
  switch (tokenPeriod.value) {
    case 'daily':
      trendData = dashboardData.value.tokenTrendDaily;
      periodLabel = '最近30天';
      break;
    case 'weekly':
      trendData = dashboardData.value.tokenTrendWeekly;
      periodLabel = '最近12周';
      break;
    case 'monthly':
      trendData = dashboardData.value.tokenTrendMonthly;
      periodLabel = '最近12个月';
      break;
  }

  const option = {
    title: {
      text: `Token消耗趋势 - ${periodLabel}`,
      textStyle: { fontSize: 16 }
    },
    tooltip: { trigger: 'axis' },
    legend: { data: ['Token消耗'] },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: trendData.map(item => item.label)
    },
    yAxis: { type: 'value' },
    series: [{
      name: 'Token消耗',
      type: 'line',
      smooth: true,
      data: trendData.map(item => item.value),
      itemStyle: { color: '#409EFF' },
      areaStyle: { opacity: 0.3 }
    }]
  };

  tokenChart.setOption(option);
};

// 更新用户图表
const updateUserChart = () => {
  if (!userChart || !dashboardData.value) return;

  let trendData;
  let periodLabel;
  
  switch (userPeriod.value) {
    case 'daily':
      trendData = dashboardData.value.newUserTrendDaily;
      periodLabel = '最近30天';
      break;
    case 'weekly':
      trendData = dashboardData.value.newUserTrendWeekly;
      periodLabel = '最近12周';
      break;
    case 'monthly':
      trendData = dashboardData.value.newUserTrendMonthly;
      periodLabel = '最近12个月';
      break;
  }

  const option = {
    title: {
      text: `新用户增长趋势 - ${periodLabel}`,
      textStyle: { fontSize: 16 }
    },
    tooltip: { trigger: 'axis' },
    legend: { data: ['新用户'] },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: trendData.map(item => item.label)
    },
    yAxis: { type: 'value' },
    series: [{
      name: '新用户',
      type: 'line',
      smooth: true,
      data: trendData.map(item => item.value),
      itemStyle: { color: '#67C23A' },
      areaStyle: { opacity: 0.3 }
    }]
  };

  userChart.setOption(option);
};

// 切换Token图表时间周期
const onTokenPeriodChange = () => {
  updateTokenChart();
};

// 切换用户图表时间周期
const onUserPeriodChange = () => {
  updateUserChart();
};

// 加载数据
const loadDashboardData = async () => {
  try {
    loading.value = true;
    const response = await getAdminDashboardStats();
    dashboardData.value = response.data;
    initCharts();
  } catch (error) {
    console.error('Failed to load dashboard data:', error);
  } finally {
    loading.value = false;
  }
};

// 页面加载完成后获取数据
onMounted(() => {
  loadDashboardData();
});

// 当窗口大小改变时，调整图表尺寸
const handleResize = () => {
  if (tokenChart) tokenChart.resize();
  if (userChart) userChart.resize();
};

// 添加窗口大小改变事件监听器
window.addEventListener('resize', handleResize);

// 在组件卸载时销毁图表实例
onUnmounted(() => {
  if (tokenChart) {
    tokenChart.dispose();
    tokenChart = null;
  }
  if (userChart) {
    userChart.dispose();
    userChart = null;
  }
  window.removeEventListener('resize', handleResize);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ElRow), {
      gutter: 20,
      class: "dashboard-stats"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElCol), { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElCard), {
              shadow: "hover",
              class: "stat-card"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(ElIcon), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ChatLineRound))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(dashboardData.value?.todayTokenUsage || 0), 1),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "stat-label" }, "今日Token消耗", -1))
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(ElCol), { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElCard), {
              shadow: "hover",
              class: "stat-card"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_unref(ElIcon), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(User))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(dashboardData.value?.onlineUsers || 0), 1),
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "stat-label" }, "在线人数", -1))
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(ElCol), { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElCard), {
              shadow: "hover",
              class: "stat-card"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_unref(ElIcon), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(UserFilled))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(dashboardData.value?.newUsersToday || 0), 1),
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "stat-label" }, "今日新用户", -1))
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(ElCol), { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElCard), {
              shadow: "hover",
              class: "stat-card"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_unref(ElIcon), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Warning))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(pendingTotal.value), 1),
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "stat-label" }, "待处理事项", -1))
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(ElRow), {
      gutter: 20,
      class: "dashboard-overview"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElCol), { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElCard), null, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, [
                  _cache[9] || (_cache[9] = _createElementVNode("span", null, "Token消耗趋势", -1)),
                  _createVNode(_unref(ElRadioGroup), {
                    modelValue: tokenPeriod.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tokenPeriod).value = $event)),
                    size: "small",
                    onChange: onTokenPeriodChange
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElRadioButton), { value: "daily" }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createTextVNode("日", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_unref(ElRadioButton), { value: "weekly" }, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                          _createTextVNode("周", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_unref(ElRadioButton), { value: "monthly" }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode("月", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", {
                  ref_key: "tokenChartRef",
                  ref: tokenChartRef,
                  class: "chart-container"
                }, null, 512)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(ElCol), { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElCard), null, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_19, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", null, "新用户增长趋势", -1)),
                  _createVNode(_unref(ElRadioGroup), {
                    modelValue: userPeriod.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userPeriod).value = $event)),
                    size: "small",
                    onChange: onUserPeriodChange
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElRadioButton), { value: "daily" }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                          _createTextVNode("日", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_unref(ElRadioButton), { value: "weekly" }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode("周", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_unref(ElRadioButton), { value: "monthly" }, {
                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                          _createTextVNode("月", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", {
                  ref_key: "userChartRef",
                  ref: userChartRef,
                  class: "chart-container"
                }, null, 512)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(ElRow), {
      gutter: 20,
      class: "dashboard-additional-stats"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElCol), { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElCard), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_20, [
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "stat-title" }, "总用户数", -1)),
                  _createElementVNode("div", _hoisted_21, _toDisplayString(dashboardData.value?.totalUsers || 0), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(ElCol), { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElCard), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_22, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "stat-title" }, "总帖子数", -1)),
                  _createElementVNode("div", _hoisted_23, _toDisplayString(dashboardData.value?.totalPosts || 0), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(ElCol), { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElCard), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_24, [
                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "stat-title" }, "总评论数", -1)),
                  _createElementVNode("div", _hoisted_25, _toDisplayString(dashboardData.value?.totalComments || 0), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(ElRow), {
      gutter: 20,
      class: "dashboard-pending-stats"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElCol), { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElCard), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_26, [
                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "stat-title" }, "待审核帖子", -1)),
                  _createElementVNode("div", _hoisted_27, _toDisplayString(dashboardData.value?.pendingPostCount || 0), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(ElCol), { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElCard), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_28, [
                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "stat-title" }, "待审核评论", -1)),
                  _createElementVNode("div", _hoisted_29, _toDisplayString(dashboardData.value?.pendingCommentCount || 0), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(ElCol), { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElCard), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_30, [
                  _cache[19] || (_cache[19] = _createElementVNode("div", { class: "stat-title" }, "待处理举报", -1)),
                  _createElementVNode("div", _hoisted_31, _toDisplayString(dashboardData.value?.pendingReportCount || 0), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})